import script from "./DataTablePageSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTablePageSelector.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__